import { Component, h } from '@stencil/core';

@Component({
  tag: 'qumra-checkout-button',
  styleUrl: 'qumra-checkout-button.css',
  shadow: false,
})
export class QumraCheckoutButton {
  // دالة تقوم بتشغيل checkout عند الضغط على الزر
  handleCheckout() {
    if (window.Qumra && window.Qumra.order && typeof window.Qumra.order.checkout === 'function') {
     window.Qumra.order.checkout();
    } else {
      console.warn('window.qumra.order.checkout is not available');
    }
  }

  render() {
    return (
        <button aria-label="UIhandleCheckout" class={"qumra-checkout-button"} onClick={() => this.handleCheckout()}> <slot></slot></button>
    );
  }
}